import * as XLSX from "xlsx";
import axios from "axios";
import { devApiUrl } from "../config";

export const readExcelFile = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // Do whatever you want with the file contents
      const binaryStr = reader.result;
      const data = new Uint8Array(binaryStr);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      let jsonData = XLSX.utils.sheet_to_json(worksheet);

      // Iterate over jsonData to convert OwnerID to string if it is not empty
      jsonData = jsonData.map((row) => {
        if ("OwnerID" in row && row["OwnerID"]) {
          row["OwnerID"] = String(row["OwnerID"]);
        }
        return row;
      });

      resolve(jsonData);
    };
    reader.onerror = () => {
      reject(new Error("Error reading file"));
    };
    reader.onabort = () => {
      reject(new Error("Error reading file"));
    };
    reader.readAsArrayBuffer(file);
  });
};

// in fileHandlers/ConvertFiles or wherever readExcelFile is located

const CHUNK_SIZE = 1 * 1024 * 1024; // 1MB, adjust as needed

export const uploadFileInChunks = async (file, dataModelId, fileName) => {
  const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

  for (let i = 0; i < totalChunks; i++) {
    const chunk = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
    await uploadChunk(chunk, i, fileName);
  }

  // After all chunks are uploaded, notify the backend to combine them
  await axios.post(`${devApiUrl}/combine-chunks`, {
    fileName: fileName,
    dataModelId: dataModelId,
  });
};

const uploadChunk = async (chunk, chunkNumber, fileName, dataModelId) => {
  const formData = new FormData();
  formData.append("fileChunk", chunk); // Ensure this matches the name expected by FastAPI
  formData.append("chunkNumber", chunkNumber);
  formData.append("fileName", fileName);
  formData.append("dataModelId", dataModelId);

  await axios.post(`${devApiUrl}/upload-chunk`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
